import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiLeaseService } from '../../data/services/api/api-lease.service';
import { LeaseService } from '../../data/services/view/lease.service';

@Component({
  selector: 'app-lease-form-create',
  templateUrl: './lease-form-create.component.html',
  styleUrls: ['./lease-form-create.component.scss']
})
export class LeaseFormCreateComponent implements OnInit, OnDestroy {
  // Búsqueda server-side de clientes con debounce (nombre O RFC).
  private clientSearch$ = new Subject<string>()
  private clientSearchSubscription!: Subscription

  constructor(
    public apiLeaseService: ApiLeaseService,
    public leaseService: LeaseService,
  ) { }

  ngOnInit() {
    this.clientSearchSubscription = this.clientSearch$
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(term => this.leaseService.searchClients(term))
  }

  ngOnDestroy() {
    if (this.clientSearchSubscription) {
      this.clientSearchSubscription.unsubscribe()
    }
  }

  onClientFilter(event: any) {
    this.clientSearch$.next(event?.filter ?? '')
  }
}
